import React from 'react';

const DateFmt = ({ children }) => {
    
    if(children === null)
        return ('');
    
    // Convert children to a Date object
    const dateStr = children;

    const validDate = new Date(dateStr);

    // Check if the date is valid
    if (isNaN(validDate.getTime())) {
        return <span>Invalid date</span>;
    }

    // Format the date as "Jun 14 2024"
    const month = validDate.toLocaleDateString('en-US', { month: 'short' });
    const day = validDate.getDate();
    const year = validDate.getFullYear();
    const formattedDate = `${month} ${day} ${year}`;

    return (
        <span>{formattedDate}</span>
    );
};

export default DateFmt;